import BaseComponentController from '../../../../components/base-component.controller';

class ConflictCategoryController extends BaseComponentController {
    constructor(_, componentRegistryService, $q) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors: []
        };
        this.selectedCategoryDescription = null;
    }

    init() {
        this.vm = {
            errors:[]
        };
        if (this.model && this.readonly) {
            this.selectedCategoryDescription = this.getCategoryDescription(this.model.id);
        }
        if (this.model && !this.readonly) {
            this.conflictCategorySelected();
        }
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        if (this._.isEmpty(this.model) ||this._.isEmpty(this.model.id)) {
            this.vm.errors = [`${this.fieldName} is a required field`];
        } else {
            this.vm.errors = [];
        }
        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }

    conflictCategorySelected() {
        this.vm = {
            errors:[]
        };
        this.onCategoryUpdated({ model: this.model });
    }
    
    getCategoryDescription(categoryId) {
        return this._.find(this.conflictCategories, (value, key) => value.id === categoryId).description;
    }
}

ConflictCategoryController.$inject = ['_', 'componentRegistryService','$q'];

export default  {
    controller: ConflictCategoryController,
    bindings: {
        modelName:'@',
        fieldName: '@',
        conflictCategories: '<',
        onCategoryUpdated : '&',
        readonly: '<'
    },
    templateUrl:`app/disclose/conflictOfInterest/components/conflict-category/conflict-category.html`
};




// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/components/conflict-category/conflict-category.component.js